import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { CartCouponModule, CartSharedModule } from '@spartacus/cart/base/components'
import { CmsConfig, FeaturesConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { CardModule, FormErrorsModule, PromotionsModule, PwaModule } from '@spartacus/storefront'
import { CustomCartSharedModule } from '../../cart/cart-shared/custom-cart-shared.module'
import { CustomOrderConfirmationThankYouMessageComponent } from './custom-order-confirmation-thank-you-message/custom-order-confirmation-thank-you-message.component'
import { CustomOrderConfirmationTotalsComponent } from './custom-order-confirmation-totals/custom-order-confirmation-totals.component'
import { CustomOrderConfirmationItemsComponent } from './custom-order-confirmation-items/custom-order-confirmation-items.component'
import { OrderConfirmationModule } from '@spartacus/order/components'
import { CustomOrderDetailsModule } from '../custom-order-details/custom-order-details.module'
import { CustomOrderConfirmationOverviewComponent } from './custom-order-confirmation-overview/custom-order-confirmation-overview.component'
import { CustomOrderConfirmationShippingComponent } from './custom-order-confirmation-shipping/custom-order-confirmation-shipping.component'

@NgModule({
  declarations: [
    CustomOrderConfirmationItemsComponent,
    CustomOrderConfirmationShippingComponent,
    CustomOrderConfirmationOverviewComponent,
    CustomOrderConfirmationThankYouMessageComponent,
    CustomOrderConfirmationTotalsComponent
  ],
  imports: [
    CommonModule,
    CustomCartSharedModule,
    CardModule,
    PromotionsModule,
    I18nModule,
    ReactiveFormsModule,
    FeaturesConfigModule,
    FormErrorsModule,
    CartCouponModule,
    CartSharedModule,
    OrderConfirmationModule,
    PwaModule,
    CustomOrderDetailsModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        OrderConfirmationThankMessageComponent: {
          component: CustomOrderConfirmationThankYouMessageComponent
        },
        OrderConfirmationShippingComponent: {
          component: CustomOrderConfirmationShippingComponent
        },
        OrderConfirmationItemsComponent: {
          component: CustomOrderConfirmationItemsComponent
        },
        OrderConfirmationTotalsComponent: {
          component: CustomOrderConfirmationTotalsComponent
        }
      }
    })
  ],
  exports: [
    CustomOrderConfirmationItemsComponent,
    CustomOrderConfirmationShippingComponent,
    CustomOrderConfirmationOverviewComponent,
    CustomOrderConfirmationThankYouMessageComponent,
    CustomOrderConfirmationTotalsComponent
  ]
})
export class CustomOrderConfirmationModule {}
